export function CheckBadge() {
   return <img src="/assets/icons/memberships/check-badge.svg" alt="" width={16} height={16} />;
}

export function GreenCheck() {
   return (
      <svg width="16" height="10" viewBox="0 0 16 10" fill="none">
         <path d="M1 5L5.5 9.5L15 0" stroke="#68C072" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
   );
}

export function GreyDash() {
   return (
      <svg width="13" height="2" viewBox="0 0 13 2" fill="none">
         <line x1="0" y1="1" x2="12.5" y2="1" stroke="#5A5B60" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
   );
}
